export const AI_NOT_ALLOWED = "zz_AgentApiErrorCode_AiNotAllowedForOrganization";

export const AI_NOT_ALLOWED_NOTE =
  "Organisasjonens KI-innstilling tillater ikke denne KI-funksjonen. Kontakt SourceMagnet for å endre hvor dataene deres kan behandles.";

export const isAiNotAllowed = (error: unknown): boolean =>
  (error as { data?: { errorCode?: unknown } } | null)?.data?.errorCode === AI_NOT_ALLOWED;
